import { IListState, PaginationType } from '@typings/requestPayloads'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { STATUS } from '@features/General'

export interface IListQueryPaginationPayload {
    pagination?: PaginationType
    query?: any
    token: string
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const listHallByToken = createSlice({
    name: 'meeting-requests/list-hall-by-token',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        replaceItem(state, action) {
            const findIndex = state.data.findIndex(item => item._id === action.payload._id)
            state.data[findIndex] = action.payload
        }
    }
})

export const listHallByTokenActions = listHallByToken.actions
export default listHallByToken.reducer
